<template>
  <div class="online-cv-wrapper" :style="iosOrAndroidStyle">
    <template v-if="!loadingShow">
      <w-nav-bar @mobileLeftBtn="routerBack" v-show="iosOrAndroidShow"/>
      <div class="online-header">
        <p class="headline title">选择一份简历开启推荐</p>
        <p class="description">简历建议及时更新，获得优质 HR 推荐</p>
      </div>
      <div class="cv-list">
        <div class="cv-list-item flex-start" v-for="(item, index) in draftCvList" :key="index"
             @click="selectCvItem(item, index)">
          <input type="radio" class="radio-fit flex-center" name="onlineCv" :checked="checkedIndex === index">
          <div class="cv-container flex-start">
            <div class="cv-logo flex-center">
              <img src="https://files.wondercv.com/mobile/cvs/cv-logo.png" alt="">
            </div>
            <div class="cv-info flex-column-between">
              <div class="cv-top">{{ item.cv_name || '未命名超级简历' }}</div>
              <div class="cv-middle flex">
                <p class="cv-lang cv flex-center">{{ item.lang | langFilter }}</p>
                <p class="cv-score cv flex-center">{{ item.score || 40 }}分</p>
                <p class="cv-module cv flex-center">{{ item.cv_type | templateFilter }}</p>
              </div>
              <div class="cv-bottom flex-between">
                <p>{{ item.update_time | timeFormatFilter }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="online-footer footer">
        <button class="theme-button flex-center footer-button" @click="nextStep">下一步</button>
      </div>
    </template>
    <w-loading v-if="loadingShow"/>
  </div>
</template>

<script>
	import WNavBar from '@/components/global/w-navbar'
	import { mapActions, mapState, mapMutations } from 'vuex'
	import { envMixin } from '@/assets/js/mixin/global'
	import { componentsMixin } from '@/assets/js/mixin/components'
	import WLoading from '../../components/global/w-loading'
	import { onlineMixin } from '../../assets/js/mixin/cv'

	export default {
		name: 'cv-list',
		mixins: [ envMixin, componentsMixin, onlineMixin ],
		data () {
			return {
				loadingShow: true
			}
    },
    async created () {
			this.changeOnlineCvBasic({})
      this._getCvList()
    },
		mounted () {
			
		},
		computed: {},
		watch: {},
		components: {
			WNavBar, WLoading
		},
		methods: {
			...mapMutations('cv', [ 'changeOnlineCvBasic' ]),
			selectCvItem (item, index) {
				this.checkedIndex = index
			},
			routerBack () {
				this.$router.back()
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/mixin';
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/cv/online-cv';
  .cv-list {
    padding: 0 24px;
    .cv-list-item {
      padding: 24px 0;
      border-bottom: 1px solid #EEEFF0;
      &:last-child {
        border-bottom: none;
      }
      .cv-container {
        width: calc(100vw - 88px);
        .cv-logo {
          border: 1px solid #dedfe1;
          border-radius: 6px;
          width: 80px;
          height: 80px;
          margin-right: 12px;
          img {
            width: 30px;
          }
        }
        .cv-info {
          width: calc(100% - 92px);
          height: 80px;
          .cv-top {
            font-size: $font-size-medium-x;
            color: $color-title;
            font-weight: 600;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 216px;
            line-height: 18px;
          }
          .cv-middle {
            .cv {
              padding: 6px 10px;
              border-radius: 2px;
              font-size: $font-size-small;
              font-weight: 400;
              white-space: nowrap;
            }
            .cv-lang {
              background-color: #d5e8fe;
              color: #4183fe;
              margin-right: 6px;
            }
            .cv-score {
              background-color: #fee9e9;
              color: $color-theme;
              margin-right: 6px;
            }
            .cv-module {
              background-color: #f1f2f6;
              color: $color-title;
            }
            .cv-not-edit {
              background-color: #f1f2f6;
              color: $color-title;
            }
          }
          .cv-bottom {
            color: #9c9c9c;
            font-size: $font-size-small;
            font-weight: 400;
          }
        }
      }
    }
  }
</style>
